import { DateRange } from '@/models/helpers'

import { formatDateOnly } from './format-date-only'

// Note: Format is -> 2/20/2026 - 2/21/2026
export const formatDateRange = (range: DateRange): string => {
  if (!range[0]) return ''
  if (!range[1]) return `${formatDateOnly(range[0])} -`
  return `${formatDateOnly(range[0])} - ${formatDateOnly(range[1])}`
}
